import { createFileRoute } from "@tanstack/react-router";

import { BuilderPage } from "~/components/builder/builder-page";
import {
  buildBuilderPageMeta,
  loadBuilderPageContent,
} from "~/lib/builder/page";
import { BRAND_PEOPLE, BRAND_URL } from "~/lib/shared/brand";
import {
  createBrandPersonStructuredData,
  createBreadcrumbStructuredData,
} from "~/lib/shared/meta";

const URL_PATH = "/about";
const CANONICAL_URL = `${BRAND_URL}${URL_PATH}`;

const AboutPage = () => <BuilderPage content={Route.useLoaderData()} />;

export const Route = createFileRoute("/_public/about/")({
  staticData: { title: "About" },
  staleTime: 6 * 60 * 60 * 1000, // 6 hours
  loaderDeps: ({ search }) => ({ search }),
  loader: ({ deps }) =>
    loadBuilderPageContent({ urlPath: URL_PATH, search: deps.search }),
  head: ({ loaderData }) => ({
    ...buildBuilderPageMeta({
      content: loaderData,
      canonicalUrl: CANONICAL_URL,
    }),
    // The About page anchors the brand's Person nodes: BRAND_PEOPLE @ids point
    // at /about#yuri-minski and /about#marcel-samyn, so this page must emit
    // the Person JSON-LD for those fragments to resolve (issue #757).
    scripts: [
      {
        type: "application/ld+json",
        children: JSON.stringify(
          createBrandPersonStructuredData(BRAND_PEOPLE.yuri),
        ),
      },
      {
        type: "application/ld+json",
        children: JSON.stringify(
          createBrandPersonStructuredData(BRAND_PEOPLE.marcel),
        ),
      },
      {
        type: "application/ld+json",
        children: JSON.stringify(
          createBreadcrumbStructuredData([
            { name: "Home", url: BRAND_URL },
            { name: "About", url: CANONICAL_URL },
          ]),
        ),
      },
    ],
  }),
  component: AboutPage,
});
